<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__appurl">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.urlName" placeholder="URL名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.urlType" placeholder="URL类型" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in urlTypeList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:appurl:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:appurl:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="url" label="URL" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="urlName" label="名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="urlType" label="类型" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.urlType === '0'" type="success">H5地址</el-tag>
            <el-tag v-else-if="scope.row.urlType === '1'" type="primary">下载地址</el-tag>
            <el-tag v-else type="info">{{ scope.row.urlType }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="urlSort" label="排序" header-align="center" align="center" width="80"></el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" type="success">启用</el-tag>
            <el-tag v-else type="danger">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:appurl:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:appurl:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './android-url-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/appurl/page',
        getDataListIsPage: true,
        deleteURL: '/sys/appurl',
        deleteIsBatch: true
      },
      dataForm: {
        urlName: '',
        urlType: ''
      },
      urlTypeList: [
        { dictLabel: 'H5地址', dictValue: '0' },
        { dictLabel: '下载地址', dictValue: '1' }
      ]
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
